import React from 'react';

//Bootstrap
import {Button, Modal} from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import {Card} from 'react-bootstrap';


//Helper functions
function ProcessTrailer(props)
{
  return(
    <>
    {props.video.map( (video, index) =>
      <iframe width="400" height="225" src={video}>
      </iframe>
    )}
    </>
  )
}

function ProcessReview(props)
{
  if(props.review == null)
  {
    return(<a></a>)
  }
  else
  {
    return(
      <>
      <h3>Reviews</h3>
      {props.review.map( (review, index) =>
        <>
          <Card id = "presskitCard" text = {'white'}>
            <Card.Body>
              <Card.Text>
                <p><i>{props.review[index]}</i></p>

                <p> - {props.reviewer[index]}, {props.score[index]} </p>
              </Card.Text>
            </Card.Body>
          </Card>
          <br></br>
          </>
        )}
      </>
    )
  }


}

function ProcessFactArray(props)
{
  if(props.fact != null)
  {
    if(props.link == null)
    {
      return(
        <>
          <br></br>
          <b>{props.text}</b> |
          {props.fact.map( (fact, index) => <a> <a>{fact}</a>  |</a>)}
          <br></br>
        </>
      )
    }
    else
    {
      return(
        <>
          <br></br>
          <b>{props.text}</b> |
          {props.fact.map( (fact, index) => <a> <a href = {props.link[index]}  target="_blank">{fact}</a>  |</a>)}
          <br></br>
        </>
      )
    }
  }
  else
  {
    return(
      <a></a>
    )
  }


}

function ProcessFactSimple(props)
{
    if(props.link == null)
    {
      return(
      <>
        <br></br>
        <b>{props.text}</b>
        <a> {props.fact}</a>
        <br></br>
      </>
      )
    }
    else
    {
      return(
      <>
        <br></br>
        <b>{props.text}</b>
        <a href = {props.link}  target="_blank"> {props.fact}</a>
        <br></br>
      </>
      )
    }

}

//Actual function
class PresskitButton extends React.Component
{

  constructor(props)
  {
      super(props);
      this.state = {
        "show": false
      }

      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
  }

  handleShow()
  {
    this.setState( {show: true});
  }

  handleClose()
  {
    this.setState( {show: false});
  }


  render()
  {
    return (
      <>
        <Button id = "carteronetext" variant="presskit" onClick={this.handleShow}>
          Open Presskit
        </Button>

        <Modal  show={this.state.show} onHide={this.handleClose} >
          <Modal.Header id = "presskitModal" closeButton>
            <a  href = {this.props.data.game_link} target="_blank">
              <Modal.Title>{this.props.data.game}</Modal.Title>
            </a>
          </Modal.Header>
          <Modal.Body id = "presskitModal">

          <h3>Factsheet</h3>
          <ProcessFactArray text = {"Created by: "} fact = {this.props.data.developer} link = {this.props.data.developer_link}/>
          <ProcessFactArray text = {"Published by: "} fact = {this.props.data.publisher} link = {this.props.data.publisher_link}/>
          <ProcessFactArray text = {"Art by: "} fact = {this.props.data.artist} link = {this.props.data.artist_link}/>
          <ProcessFactArray text = {"Music by: "} fact = {this.props.data.music} link = {this.props.data.music_link}/>
          <ProcessFactArray text = {"Platforms: "} fact = {this.props.data.platform} link = {this.props.data.platform_link}/>
          <ProcessFactSimple text = {"Price: "} fact = {this.props.data.price} link = {null}/>
          <ProcessFactArray text = {"Release: "} fact = {this.props.data.release} link = {null}/>
          <ProcessFactSimple text = {"Contact: "} fact = {this.props.data.contact} link = {null}/>
          <ProcessFactSimple text = {"Website: "} fact = {this.props.data.website} link = {"https://" + this.props.data.website}/>
          <ProcessFactSimple text = {"Twitter: "} fact = {this.props.data.twitter} link = {this.props.data.twitter_link}/>
          <ProcessFactSimple text = {"YouTube: "} fact = {this.props.data.youtube} link = {this.props.data.youtube_link}/>
          <ProcessFactArray text = {"Languages: "} fact = {this.props.data.languages} link = {null}/>
          <br></br>
          <br></br>
          <br></br>


          <h3>Description</h3>
          <p id = "markdown"><ReactMarkdown source = {this.props.data.description}/></p>
          <br></br>
          <br></br>


          <h3>History</h3>
          <p id = "markdown" ><ReactMarkdown source = {this.props.data.history}/></p>
          <br></br>
          <br></br>

          <ProcessReview review = {this.props.data.review} reviewer = {this.props.data.reviewer} score = {this.props.data.score} />

          <h3>Trailers</h3>
          <ProcessTrailer video = {this.props.data.video}/>

          <br></br>
          <br></br>
          <h3>Assets</h3>
          <br></br>
          <Button target="_blank" href = {this.props.data.screenshots} variant="presskit" onClick={this.handleShow}>
            Screenshots
          </Button>
          <br></br>
          <br></br>
          <Button target="_blank" href = {this.props.data.keyart} variant="presskit" onClick={this.handleShow}>
            Key Art
          </Button>



          </Modal.Body>
          <Modal.Footer id = "presskitModal">
            <Button variant="btn btn-outline-danger" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default PresskitButton;
